<div class="sku-nest-summary">
  <div class="header-row">
    @for (col of displayData; track col) {
      <div
        class="col"
        [class.disabled-nest]="
          col.label === '1 SKU Nest' || col.label === '2 SKU Nest'
        "
      >
        {{ col.label }}
        @if (col.label === "1 SKU Nest" || col.label === "2 SKU Nest") {
          <img
            src="/assets/images/info.svg"
            alt="icon"
            pTooltip="Optimization does not work on this SKU Nest"
            tooltipPosition="top"
            class="cursor-pointer info-icon"
          />
        }
      </div>
    }
  </div>
  <div class="content-row">
    @for (col of displayData; track col) {
      <div class="col">
        @if (!showLoader) {
          <span class="count">
            {{ col.nests }} nests
            <span class="percent">({{ formatPercent(col.percent) }})</span>
          </span>
        } @else {
          <p-skeleton width="80%" height="14px"></p-skeleton>
        }
      </div>
    }
  </div>
</div>
